export default {
  list: {
    colName: "Name",
    colContact: "Contact",
    colBalance: "Balance",
    colActions: "Actions",
    statusActive: "Active",
    statusInactive: "Inactive",
    retry: "Retry",
    emptySearch: "No results match your search.",
    filterRole: "Role",
    filterRoleAll: "All",
    filterRoleSeller: "Sellers",
    filterRoleHost: "Hosts",
    filterRoleSalesAgent: "Sales agents",
    filterRoleAdmin: "Staff",
    statusTooltipActive: "Active account",
    statusTooltipInactive: "Inactive account",
    filterStatus: "Status",
    filterAll: "All",
    filterActive: "Active",
    filterInactive: "Inactive",
    openRowAria: "Open user {{name}}",
    relevantSeller_one: "{{count}} activity",
    relevantSeller_other: "{{count}} activities",
    relevantHost_one: "{{count}} structure",
    relevantHost_other: "{{count}} structures",
    relevantSalesAgent_one: "{{count}} association",
    relevantSalesAgent_other: "{{count}} associations",
  },
  detail: {
    backToUsers: "Back to users",
    activate: "Activate",
    deactivate: "Deactivate",
    statWallet: "Wallet Balance",
    statRevenue: "Total Revenue",
    contactCard: "Contact Information",
    email: "Account email",
    phone: "Phone",
    contactEmail: "Contact email",
    vatNumber: "VAT number",
    billingAddress: "Billing address",
    legalInfoCard: "Legal profile",
    editLegalInfo: "Edit profile",
    cancelEditLegalInfo: "Cancel editing",
    loadLegalInfo: "Loading legal profile...",
    loadLegalInfoError: "Failed to load legal profile",
    sendPasswordReset: "Send password reset email",
    toastPasswordResetSent: "Password reset email sent.",
    lastLogin: "Last access",
    lastLoginNever: "Never logged in",
    passwordResetActiveLink:
      "A setup link is still valid until {when}. Wait for it to expire before sending another.",
    passwordResetCooldown:
      "A reset email was sent recently. You can send another after {when}.",
    transactionsTitle: "Wallet transactions",
    tabs: {
      ariaLabel: "User profile sections",
      overview: "Overview",
      activities: "Activities",
      activitiesDesc: "Owned experiences",
      structures: "Structures",
      structuresDesc: "Houses & devices",
      associations: "Associations",
      associationsDesc: "Activity & structure scope",
      legal: "Legal",
      legalDesc: "Billing, ID & payment",
      transactions: "Transactions",
    },
    statusActive: "Active",
    statusInactive: "Inactive",
    editDisplayName: "Edit display name",
    displayNamePlaceholder: "Display name",
    displayNameEmpty: "Display name cannot be empty",
    toastDisplayNameUpdated: "Display name updated",
    toastDisplayNameError: "Failed to update display name",
    addActivity: "Add activity",
    addHouse: "Add structure",
    searchActivitiesPlaceholder: "Search activities…",
    noActivitiesMatchTitle: "No activities match",
    noActivitiesMatchDesc: "Try another search or status filter.",
    active: "Active",
    inactive: "Inactive",
    houseRowCommission: "{{percent}}% commission",
    moreActions: "More actions",
    shortcutsTitle: "Jump to",
  },
  createModal: {
    nameLabel: "Name",
    emailLabel: "Email",
    phoneLabel: "Contact phone",
    phonePlaceholder: "+39…",
    phoneRequired: "Enter a contact phone",
    regionLabel: "Payment region *",
    chooseRegion: "Select region…",
    regionRequired: "Select a payment region",
    inviteEmailHint:
      "We will send an invitation email so they can set their own password.",
  },
  roles: {
    seller: "Seller",
    host: "Host",
    "sales-agent": "Sales agent",
    admin: "Staff",
  },
  unified: {
    title: "Users",
    subtitle: "Sellers, hosts, sales agents, and staff in one place",
    addButton: "Add user",
    searchPlaceholder: "Search by name, email, or ID...",
    loadError: "Failed to load users",
    empty: "No users yet",
    colCount: "Count",
  },
  impersonate: "Impersonate",
  rolePicker: {
    title: "What type of user do you want to add?",
    seller: "Seller",
    host: "Host",
    salesAgent: "Sales agent",
    staff: "Staff",
    sellerDesc: "Partner offering experiences, services or restaurants",
    hostDesc: "Owner of houses where kiosks are installed",
    salesAgentDesc: "Earns commissions on assigned activities and structures",
    staffDesc: "Internal team member with configurable permissions",
  },
  createStaffModal: {
    title: "Add staff user",
    namePlaceholder: "Staff member name",
    emailPlaceholder: "staff@example.com",
    presetLabel: "Staff preset *",
    choosePreset: "Select a preset…",
    presetRequired: "Select a staff preset",
    create: "Send invite",
    createSuccess: "Staff user created — invitation email sent",
    createError: "Could not create staff user",
  },
  staffAccess: {
    title: "Permissions for {{name}}",
    subtitle:
      "Assign a preset to follow its live permissions, or use Custom for a personal permission set.",
    loading: "Loading permissions…",
    loadError: "Could not load staff permissions",
    userNameFallback: "Staff user",
    preset: "Staff preset",
    presetHint:
      "Preset-bound users pick up definition changes automatically. Editing permissions switches to Custom.",
    presetCustom: "Custom",
    enabledSummary: "{{count}} of {{total}} enabled",
    permissionsHintPresetBound:
      "Showing the live preset permissions. Toggling any permission detaches onto Custom.",
    requiresPermissions: "Enable these permissions first:",
    searchPermissions: "Search permissions or scopes…",
    searchEmpty: "No permissions match your search",
    cannotEditSelfTitle: "Your own permissions",
    cannotEditSelf:
      "You can’t change your own staff access. Ask another Super Admin to update it.",
    immutableSuperTitle: "Super Admin",
    immutableSuper:
      "Super Admin access can’t be changed here — promote or demote only via ops scripts (`set_super_admin.py`).",
    saveSuccess: "Staff permissions updated",
    saveError: "Could not update staff permissions",
    presets: {
      super_admin: "Super Admin",
      device_tech: "Device technician",
      data_entry: "Data entry",
      accounting: "Accounting",
      user_management: "User management",
    },
    scopes: {
      stats: "Platform balance",
      users: "Users",
      activities: "Activities",
      houses: "Houses",
      storage: "Storage",
      devices: "Devices",
      readers: "Readers",
      bookings: "Bookings",
      handshakes: "Handshakes",
      customer_support: "Customer support",
      partner_support: "Partner support",
      payments: "Payments",
      alerts: "Alerts",
      protocols: "Protocols",
      carousel: "Carousel",
      agent_transcripts: "Voice transcripts",
    },
  },
} as const;
